export default __webpack_public_path__ + "static/media/INTJ-2.f6ed064e.png";